/**
 * useSmartChoiceFlags
 *
 * Gathers feature flags for SmartChoice
 * Separated for single responsibility and independent memoization
 */

import { useMemo } from 'react';

import { ConstantsLagoon } from '../../../common/ConstantsLagoon';
import { getFeatureFlag } from '../../../common/Utils';
import { returnSuppressFlag } from '../../../utils/featureSuppress';
import { useLagoon } from '../../useLagoon';
import { SmartChoiceFlags } from '../smartChoice.config';

/**
 * Hook to gather all SmartChoice feature flags
 *
 * @returns Memoized flags object
 */
export function useSmartChoiceFlags(): SmartChoiceFlags {
  const featureFlags: [{ key: string; active: boolean }] =
    useLagoon('feature-flags')();

  const enablePSXProviderRecommendations = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_PSX_PROVIDER_RECOMMENDATIONS
  );
  const enablePSXFacilitiesRecommendations = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_PSX_FACILITIES_RECOMMENDATIONS
  );
  const isSmartChoiceSuppressed = returnSuppressFlag(
    ConstantsLagoon.FEATURE_SUPPRESSION_FLAGS.SMART_CHOICE
  );

  return useMemo(
    () => ({
      enablePSXProviderRecommendations,
      enablePSXFacilitiesRecommendations,
      isSmartChoiceSuppressed,
    }),
    [
      enablePSXProviderRecommendations,
      enablePSXFacilitiesRecommendations,
      isSmartChoiceSuppressed,
    ]
  );
}
